import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray('.scroll-video-wrapper').forEach((panel) => {
    const video = panel.querySelector('.scroll-video');
    let tl;
    video.onloadedmetadata = function () {
        tl = gsap.timeline({
            scrollTrigger: {
                trigger: panel,
                pin: true,
                start: 'top top',
                end: '+=100%',
                scrub: true,
                allowAnimation: true,
                onLeave: (self) => {
                    self.scroll(self.start);
                    self.disable();
                    self.animation.progress(1);
                    ScrollTrigger.refresh();
                },
            },
        });
        tl.to(video, {
            currentTime: video.duration || 1,
            ease: 'none',
        });
    };
});

const autoplayVideos = document.querySelectorAll('.autoplay-video-wrapper');
autoplayVideos.forEach((video) => {
    const videoElem = video.querySelector('video');
    ScrollTrigger.create({
        trigger: videoElem,
        once: true,
        onEnter: () => videoElem.play(),
        onLeave: () => {
            videoElem.pause();
            videoElem.currentTime = videoElem.duration;
        },
    });
});
